<template>
    <div class="goods-box">
        <div v-for="(item, index) in typeList" :key="index" class="goods-item">
            <div class="type-title bold flex">
                <div>{{ item.name }}</div>
                <a-button v-if="!item.children || item.children.length == 0" type="primary" size="small" icon="plus" @click="handleAdd(item.id)">
                    <!-- 添加门票 -->
                    {{ $t('store.add_goods') }}
                </a-button>
            </div>
            <!-- 一级 -->
            <template v-if="!item.children || item.children.length == 0">
                <a-table
                    v-if="dataSource.filter(it => it.type_id == item.id).length > 0"
                    ref="table"
                    class="mt15"
                    :rowKey="record => record.id"
                    :columns="columns"
                    :data-source="dataSource.filter(it => it.type_id == item.id)"
                    :pagination="false"
                    size="small"
                    :scroll="{ x: 1400 }"
                    :expand-icon-column-index="1"
                    :defaultExpandAllRows="true"
                    :custom-row="customRow"
                >
                    <template slot="drag" slot-scope="text, record">
                        <i class="medcon fs24 med-Drag"></i>
                    </template>
                    <span slot="index" slot-scope="text, record, index">
                        {{ index + 1 }}
                    </span>
                    <span slot="name" slot-scope="text, record">
                        <a-button @click="handleShowGoodsData(record)" type="link">{{ text }}</a-button>
                    </span>
                    <span slot="status" slot-scope="text, record">
                        <a-switch @change="handleChangeStatus(record)" :checked="record.status == 1" :checked-children="$t('store.put_away')" :un-checked-children="$t('store.sold_out')" />
                    </span>
                    <span slot="inventory" slot-scope="text, record">
                        <!-- 库存 -->
                        <span>{{ record.is_limit == 0 ? $t('store.unlimited') : record.inventory }}</span>
                        <!-- 销量 -->
                        <span>/{{ record.sale_num }}</span>
                    </span>
                    <span slot="price" slot-scope="text, record">
                        {{ currencyType[record.currency] }} :
                        {{ record.price }}
                    </span>
                    <span slot="sales_period" slot-scope="text, record">{{ record.start_time }} ~ {{ record.end_time }}</span>

                    <span slot="action" slot-scope="text, record">
                        <a @click="handleEdit(record)">
                            <!--    编辑   -->
                            {{ $t('layout.edit') }}
                        </a>
                        <a-divider type="vertical" />
                        <a @click="handleDelete(record)" class="del-button">
                            <!--    删除   -->
                            {{ $t('layout.delete') }}
                        </a>
                    </span>
                </a-table>
            </template>
            <!-- 二级 -->
            <template v-if="item.children && item.children.length > 0">
                <div v-for="(it, inde) in item.children" class="pl20 pr20" :key="inde">
                    <div class="type-title bold flex mt15">
                        <div>{{ it.name }}</div>
                        <a-button type="primary" size="small" icon="plus" @click="handleAdd(it.id)">
                            <!-- 添加门票 -->
                            {{ $t('store.add_goods') }}
                        </a-button>
                    </div>
                    <a-table
                        ref="table"
                        class="mt15"
                        :rowKey="record => record.id"
                        :columns="columns"
                        v-if="dataSource.filter(goods => goods.type_id == it.id).length > 0"
                        :data-source="dataSource.filter(goods => goods.type_id == it.id)"
                        :pagination="false"
                        size="small"
                        :scroll="{ x: 1400 }"
                        :expand-icon-column-index="1"
                        :defaultExpandAllRows="true"
                        :custom-row="customRow"
                    >
                        <template slot="drag" slot-scope="text, record">
                            <i class="medcon fs24 med-Drag"></i>
                        </template>
                        <span slot="index" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </span>
                        <span slot="name" slot-scope="text, record">
                            <a-button @click="handleShowGoodsData(record)" type="link">{{ text }}</a-button>
                        </span>
                        <span slot="status" slot-scope="text, record">
                            <a-switch @change="handleChangeStatus(record)" :checked="record.status == 1" :checked-children="$t('store.put_away')" :un-checked-children="$t('store.sold_out')" />
                        </span>
                        <span slot="inventory" slot-scope="text, record">
                            <!-- 库存 -->
                            <span>{{ record.is_limit == 0 ? $t('store.unlimited') : record.inventory }}</span>
                            <!-- 销量 -->
                            <span>/{{ record.sale_num }}</span>
                        </span>
                        <span slot="price" slot-scope="text, record">
                            {{ currencyType[record.currency] }} :
                            {{ record.price }}
                        </span>
                        <span slot=""></span>
                        <span slot="sales_period" slot-scope="text, record">{{ record.start_time }} ~ {{ record.end_time }}</span>

                        <span slot="action" slot-scope="text, record">
                            <a @click="handleEdit(record)">
                                <!--    编辑   -->
                                {{ $t('layout.edit') }}
                            </a>
                            <a-divider type="vertical" />
                            <a @click="handleDelete(record)" class="del-button">
                                <!--    删除   -->
                                {{ $t('layout.delete') }}
                            </a>
                        </span>
                    </a-table>
                </div>
            </template>
        </div>
        <!--  表格  -->

        <!--  门票详情  -->
        <goods-info
            ref="goodsInfo"
            :visible="goodsInfoVisible"
            @close="
                goodsInfoData2 = {};
                goodsInfoVisible = false;
            "
            :dataInfo="goodsInfoData2"
        />
        <!-- 门票分配  -->
        <goods-allocation ref="goodsAllocation" :visible="goodsAllocationVisible" @close="handleAllocationClose" @ok="handleAllocationOk" :dataInfo="goodsInfoData1" />
        <!-- 门票编辑  -->
        <goods-edit ref="goodsEdit" :typeList="typeList" :visible="goodsEditVisible" @ok="handleOk" @close="handleClose" :dataInfo="goodsInfoData" />
    </div>
</template>

<script>
import goodsInfo from './components/goods-info.vue';
import goodsAllocation from './components/goods-allocation.vue';
import goodsEdit from './components/goods-edit.vue';
import tableDrag from '@/utils/table.drag.mixins.js';
import { currencyType } from '@/config/const.js';
const statusTypeFilter = {
    1: 'success',
    0: 'error'
};
export default {
    name: 'Goods',
    mixins: [tableDrag],
    components: {
        goodsInfo,
        goodsAllocation,
        goodsEdit
    },
    data() {
        return {
            searchParams: {}, // 搜索条件
            statusList: [
                { label: '上架', value: 1 },
                { label: '下架', value: 0 }
            ], // 门票状态
            typeList: [], // 门票类型
            currencyType,
            columns: [
                {
                    title: this.$t('formConfig.sort' /* 排序 */),
                    scopedSlots: { customRender: 'drag' },
                    fixed: 'left',
                    width: 80
                },
                {
                    // title: '门票名称',
                    title: this.$t('store.goods_name'),
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' },
                    align: 'center',
                    fixed: 'left',
                    width: 180
                },
                {
                    // title: '金额',
                    title: this.$t('store.goods_money'),
                    dataIndex: 'price',
                    scopedSlots: { customRender: 'price' },
                    align: 'center'
                },
                // {
                //     title: this.$t('store.goods_type'),
                //     dataIndex: 'type_name',
                //     align: 'center'
                // },
                {
                    // title: '库存',
                    title: `${this.$t('store.inventory')}/${this.$t('store.sales_volume')}`,
                    dataIndex: 'inventory',
                    align: 'center',
                    scopedSlots: { customRender: 'inventory' }
                },

                // {
                //     // title: '创建人',
                //     title: this.$t('store.creator'),
                //     dataIndex: 'real_name',
                //     align: 'center',
                // },
                {
                    // title: '门票状态',
                    title: this.$t('store.goods_status'),
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    align: 'center'
                },
                {
                    // title: '销售时段',
                    title: this.$t('store.sales_period'),
                    align: 'center',
                    width: 400,
                    scopedSlots: { customRender: 'sales_period' }
                },
                {
                    // title: '操作',
                    title: this.$t('layout.operation'),
                    dataIndex: 'action',
                    width: 210,
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    fixed: 'right'
                }
            ], // 表格列
            dataSource: [], // 表格数据
            /******弹窗数据*******/
            goodsInfoVisible: false, // 门票详情弹窗
            goodsInfoData: {}, // 门票详情数据(用于编辑) 编辑表单中会监听这个数据的变化所以区分开
            goodsInfoData1: {}, // 门票详情数据(用于分配)
            goodsInfoData2: {}, // 门票详情数据(用于展示)
            goodsAllocationVisible: false, //门票分配弹窗
            goodsEditVisible: false, //门票编辑
            /******** 筛选常量  ********/
            statusFilter: {
                1: this.$t('store.put_away'), //'上架',
                0: this.$t('store.sold_out') //'下架',
            }
        };
    },
    filters: {
        statusTypeFilter(value) {
            return statusTypeFilter[value];
        },
        statusFilter(value, statusFilter) {
            return statusFilter[value];
        }
    },
    created() {
        this.getListData();
        this.getGoodsTypeList();
    },
    methods: {
        // 获取列表数据
        getListData() {
            let data = {
                page: 1,
                limit: 999
            };
            this.loading = true;
            this.$request.get({ url: 'getGoodsList', data }).then(res => {
                this.dataSource = res.data.data;
                this.loading = false;
            });
        },
        // 拖拽成功方法
        dragSuccess() {
            let ids = [];
            this.dataSource.forEach((it, idx) => {
                ids.push(it.id);
            });
            this.$request.post({ url: 'goodsSort', data: { language: this.language, ids } }).then(res => {
                this.$message.success(res.message);
            });
        },
        // 获取门票全部分类
        getGoodsTypeList() {
            this.$request.get({ url: 'getGoodsTypeList' }).then(res => {
                this.typeList = res.data;
            });
        },
        handleSearch() {
            this.getListData();
        },
        handleAdd(type_id) {
            this.goodsEditVisible = true;
            this.$nextTick(() => {
                this.goodsInfoData = {
                    type_id: type_id
                };
            });
        },
        // 展示门票详情
        handleShowGoodsData(record) {
            this.goodsInfoData2 = record;
            this.goodsInfoVisible = true;
        },
        // 门票分配
        handleAllocation(record) {
            this.goodsInfoData1 = record;
            this.goodsAllocationVisible = true;
        },
        // 门票编辑
        handleEdit(record) {
            this.$request.post({ url: 'getGoodsInfo', data: { goods_id: record.id } }).then(res => {
                this.goodsEditVisible = true;
                this.goodsInfoData = res.data;
            });
        },
        // 删除门票
        handleDelete(record) {
            if (record.status == 1) {
                this.$message.error(this.$t('store.not_delete' /* 上架中的门票不能删除 */));
                return;
            }
            this.$confirm({
                title: this.$t('web.tips' /* 提示 */),
                content: this.$t('goods.is_del_ticket' /* 是否删除该门票？ */),
                okText: this.$t('web.ok' /* 确定 */),
                cancelText: this.$t('web.cancel' /* 取消 */),
                onOk: () => {
                    let data = {
                        goods_ids: record.id
                    };
                    this.$request
                        .post({ url: 'deleteGoods', data })
                        .then(res => {
                            this.$message.success(this.$t('web.delete_success' /* 删除成功 */));
                            this.getListData();
                        })
                        .catch(err => {
                            this.$message.error(this.$t('web.delete_fail' /* 删除失败 */));
                        });
                }
            });
        },
        // 弹窗关闭
        handleOk() {
            this.getListData();
            this.goodsEditVisible = false;
        },
        handleClose() {
            this.goodsInfoData = {};
            this.goodsEditVisible = false;
        },
        handleAllocationClose() {
            this.goodsInfoData1 = {};
            this.goodsAllocationVisible = false;
        },
        handleAllocationOk() {
            this.goodsAllocationVisible = false;
            this.goodsInfoData1 = {};
            this.getListData();
        },
        handleChangeStatus(data) {
            let status = data.status == 1 ? 0 : 1;
            this.$request.post({ url: 'setGoodsStatus', data: { goods_ids: data.id, status: status } }).then(res => {
                this.pagination.current = 1;
                this.getListData();
            });
        }
    },
    computed: {}
};
</script>

<style scoped lang="less">
/deep/ .ant-form-item {
    margin-bottom: 10px !important;
}
.goods-item {
    border: 1px solid #e3e4e5;
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
}
</style>
